import React from 'react';
import { GroupSidebar, IconAgency } from '@esg/ui';
import { partnerSidebarConstants } from '../../Constants';


export const PartnerSidebar: React.FC = () => {

    return (
        <GroupSidebar
            label='Partner'
            sidebarItems={partnerSidebarConstants}
            Icon={<IconAgency.Menu.Partner />}
            border={true}
        />
    );
};
